
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@eflexsystems/ember-exam/-embroider-implicit-modules.js";
import "@eflexsystems/ember-mocha/-embroider-implicit-modules.js";
import "@ember-data/adapter/-embroider-implicit-modules.js";
import "@ember-data/debug/-embroider-implicit-modules.js";
import "@ember-data/graph/-embroider-implicit-modules.js";
import "@ember-data/json-api/-embroider-implicit-modules.js";
import "@ember-data/legacy-compat/-embroider-implicit-modules.js";
import "@ember-data/model/-embroider-implicit-modules.js";
import "@ember-data/request/-embroider-implicit-modules.js";
import "@ember-data/request-utils/-embroider-implicit-modules.js";
import "@ember-data/rest/-embroider-implicit-modules.js";
import "@ember-data/serializer/-embroider-implicit-modules.js";
import "@ember-data/store/-embroider-implicit-modules.js";
import "@ember/test-helpers/-embroider-implicit-modules.js";
import "@ember/test-waiters/-embroider-implicit-modules.js";
import "@embroider/router/-embroider-implicit-modules.js";
import "@warp-drive/core-types/-embroider-implicit-modules.js";
import "@warp-drive/ember/-embroider-implicit-modules.js";
import "@warp-drive/schema-record/-embroider-implicit-modules.js";
import "ember-basic-dropdown/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-click-outside/-embroider-implicit-modules.js";
import "ember-concurrency/-embroider-implicit-modules.js";
import "ember-data-factory-guy/-embroider-implicit-modules.js";
import "ember-flatpickr/-embroider-implicit-modules.js";
import "ember-focus-trap/-embroider-implicit-modules.js";
import "ember-freestyle/-embroider-implicit-modules.js";
import "ember-inflector/-embroider-implicit-modules.js";
import "ember-keyboard/-embroider-implicit-modules.js";
import "ember-link/-embroider-implicit-modules.js";
import "ember-modifier/-embroider-implicit-modules.js";
import "ember-power-select/-embroider-implicit-modules.js";
import "ember-resources/-embroider-implicit-modules.js";
import "ember-route-template/-embroider-implicit-modules.js";
import "ember-simple-auth/-embroider-implicit-modules.js";
import "ember-simple-track-helper/-embroider-implicit-modules.js";
import "ember-sortable/-embroider-implicit-modules.js";
import "ember-source/-embroider-implicit-modules.js";
import "ember-stargate/-embroider-implicit-modules.js";
import "ember-style-modifier/-embroider-implicit-modules.js";
import "ember-truth-helpers/-embroider-implicit-modules.js";
import "reactiveweb/-embroider-implicit-modules.js";
import "tracked-built-ins/-embroider-implicit-modules.js";
import "ember-cli-inject-live-reload/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "@eflexsystems/ember-cli-new-version/-embroider-implicit-modules.js";
import "@eflexsystems/ember-cli-webfont/-embroider-implicit-modules.js";
import "@eflexsystems/ember-composable-helpers/-embroider-implicit-modules.js";
import "@eflexsystems/ember-drag-drop/-embroider-implicit-modules.js";
import "@eflexsystems/ember-tracked-validations/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
import "@ember/jquery/-embroider-implicit-modules.js";
import "@ember/optional-features/-embroider-implicit-modules.js";
import "@ember/render-modifiers/-embroider-implicit-modules.js";
import "@ember/string/-embroider-implicit-modules.js";
import "ember-template-imports/-embroider-implicit-modules.js";
import "@embroider/util/-embroider-implicit-modules.js";
import "@fortawesome/ember-fontawesome/-embroider-implicit-modules.js";
import "@glimmer/component/-embroider-implicit-modules.js";
import "@glimmer/tracking/-embroider-implicit-modules.js";
import "@html-next/vertical-collection/-embroider-implicit-modules.js";
import "broccoli-asset-rev/-embroider-implicit-modules.js";
import "ember-ref-bucket/-embroider-implicit-modules.js";
import "ember-bootstrap/-embroider-implicit-modules.js";
import "ember-intl/-embroider-implicit-modules.js";
import "ember-simple-auth-oidc/-embroider-implicit-modules.js";
import "loader.js/-embroider-implicit-modules.js";
